import React from 'react'
import {
    Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle, useMediaQuery, Button
} from '@mui/material';

import { useTheme } from '@mui/material/styles';


const ReviewExitDialog = ({ isOpen, onClose, onConfirm }) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            <Dialog
                open={isOpen}
                onClose={onClose}
                fullScreen={fullScreen}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiPaper-root": {
                        border: '2px solid #264E5A',
                        borderRadius: '8px',
                        padding: '1rem',
                    }
                }}>

                <DialogTitle id="responsive-dialog-title">
                    Leave Reviewing Application?</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Are you sure you would like to exit this application?
                        The application will remain in pending status.
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ padding: '1rem 1.5rem' }}>
                    <Button
                        variant='outlined'
                        autoFocus
                        onClick={onClose}
                        sx={{
                            borderColor: "#00707E",
                            color: '#00707E',
                            padding: '1rem 3rem',
                            textTransform: 'none',
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: "#00707E",
                            padding: '1rem 3rem',
                            textTransform: 'none',
                        }}
                        variant='contained'
                        onClick={onConfirm}
                        autoFocus>
                        Leave
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ReviewExitDialog